function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useCallback, createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Snackbar from './Snackbar.js';
import { getRandomValue } from '../Utils/helper';
import styles from '@dtsl/css-snackbar/dist/index.module.css';
const SnackbarContext = /*#__PURE__*/createContext();
export const snackbarConstants = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
};
export function SnackbarContainer(_ref) {
  let {
    children
  } = _ref;
  const [list, setList] = useState([]);
  const [counter, setCounter] = useState(Math.floor(getRandomValue() * 100 + 1));
  return /*#__PURE__*/React.createElement(SnackbarContext.Provider, {
    value: {
      list,
      setList,
      counter,
      setCounter
    }
  }, /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement("div", {
    className: styles['sib-snackbar-container']
  }, Boolean(list) && list.map(snack => /*#__PURE__*/React.createElement(Snackbar, _extends({}, snack, {
    key: snack.identifier
  })))), document.body), children);
}
SnackbarContainer.propTypes = {
  children: PropTypes.node.isRequired
};
export function useSnackbarState() {
  const context = useContext(SnackbarContext);
  if (context === undefined) {
    throw new Error('Snackbar must be used within a SnackbarContainer');
  }
  return context;
}
export function useRemoveSnackbar() {
  const {
    setList
  } = useSnackbarState();
  const removeNodeFromList = useCallback(id => {
    if (!id) {
      throw new Error('Please provide a unique ID for the snackbar.');
    }
    setList(prevList => {
      return prevList.filter(item => item.identifier !== id);
    });
  }, []);
  return removeNodeFromList;
}
export function useSnackbar() {
  const {
    setList,
    counter,
    setCounter
  } = useSnackbarState();
  const removeNodeFromList = useCallback(id => {
    if (id) {
      setList(prevList => {
        return prevList.filter(item => item.identifier !== id);
      });
    }
  }, []);
  return _ref2 => {
    let {
      id,
      ...restProps
    } = _ref2;
    let snackbarId = id || counter + 1;
    setList(prevList => {
      let isSnackbarElement = prevList.find(item => item.identifier == id);
      if (!isSnackbarElement) {
        setCounter(snackbarId);
        let snackBarElement = {
          identifier: snackbarId,
          removeNodeFromList,
          ...restProps
        };
        return [...prevList, snackBarElement];
      } else {
        const identifier = prevList.findIndex(item => item.identifier == id);
        if (identifier >= 0) {
          return prevList.reduce((acc, curr) => {
            if (curr.identifier === id) {
              return acc.concat({
                ...curr,
                ...restProps
              });
            }
            return acc.concat(curr);
          }, []);
        }
        return prevList;
      }
    });
    return snackbarId;
  };
}
export default SnackbarContainer;